'use client';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
	user: {
		email: string;
		firstName: string;
		lastName: string;
	} | null;
	handleDismiss: () => void;
	dismissText: string | null;
}

export const UserModal = ({ user, handleDismiss, dismissText }: Props): React.JSX.Element => (
	<div style={{ width: '600px' }}>
		<Box
			onClick={handleDismiss}
			data-cy='modal-cancel-button'
			style={{
				width: '100%',
				display: 'flex',
				justifyContent: 'flex-end',
				alignItems: 'center',
				cursor: 'pointer',
			}}
		>
			<Typography style={{ marginRight: '5px', color: 'black' }}>{dismissText}</Typography>
			<CloseIcon
				style={{
					width: '25px',
					height: '25px',
					color: 'black',
				}}
			/>
		</Box>
		<Box style={{ paddingBottom: '40px', textAlign: 'center' }}>
			<AccountCircleIcon sx={{ width: '50px', height: '50px', marginBottom: '10px' }} />
			<Typography style={{ marginBottom: '10px' }} variant='h6'>
				{user.firstName} {user.lastName}
			</Typography>
			<Typography variant='h6'>{user.email}</Typography>
		</Box>
	</div>
);
